import VueRouter from "vue-router";
import Vue from "vue";

// Coming soon page
// const ComingSoon = () => import(/* webpackChunkName: "ComingSoon" */ '@/components/coming-soon/UnderDevelopment.vue')

const MalaysiaLayout = () => import("@/layouts/MalaysiaLayout.vue")
const GeneralLayout = () => import("@/layouts/GeneralLayout.vue")
const NewLayout = () => import("@/layouts/NewLayout.vue")
const GameLayout = () => import("@/layouts/GameLayout.vue")
const BlankLayout = () => import("@/layouts/BlankLayout.vue")

// Home
const Home = () =>
  import(/* webpackChunkName: "Home" */ "@/pages/home/index.vue");

// Tracking / Lacak Pengiriman
const Tracking = () =>
  import(
    /* webpackChunkName: "Tracking" */ "@/pages/new-tracking/Tracking.vue"
  );

// Check Price / Cek Tarif
const CheckRates = () =>
  import(
    /* webpackChunkName: "CheckPrice" */ "@/pages/new-check-price/CheckPrice.vue"
  );

// Agent Location
const AgentLocation = () =>
  import(
    /* webpackChunkName: "AgentLocation" */ "@/pages/new-agent-location/AgentLocation.vue"
  );

// Daftar Korporasi
const Corporation = () =>
  import(
    /* webpackChunkName: "CorporationPage" */ "@/pages/new-corporation/Corporation.vue"
  );
const CorporationForm = () =>
  import(
    /* webpackChunkName: "CorporationPage" */ "@/pages/new-corporation/form/Form.vue"
  );

// Tentang Kami
const AboutPage = () =>
  import(/* webpackChunkName: "About" */ "@/pages/new-about/AboutUspage.vue");
const BoardPage = () =>
  import(
    /* webpackChunkName: "About" */ "@/pages/new-about/board/BoardPage.vue"
  );

// Karir
const NewCareerPage = () =>
  import(/* webpackChunkName: "Career" */ "@/pages/new-career/Career.vue");
const NewCareerListPage = () =>
  import(
    /* webpackChunkName: "CareerList" */ "@/pages/new-career/jobs/Jobs.vue"
  );
const NewDetailCareerPage = () =>
  import(
    /* webpackChunkName: "CareerDetail" */ "@/pages/new-career/detail/Detail.vue"
  );
const NewCareerForm = () =>
  import(
    /* webpackChunkName: "CareerForm" */ "@/pages/new-career/form/Form.vue"
  );

// Promo
const NewProgramPage = () =>
  import(/* webpackChunkName: "Promo" */ "@/pages/new-program/Program.vue");
const NewDetailPromoPage = () =>
  import(
    /* webpackChunkName: "Promo" */ "@/pages/new-program/detail/Detail.vue"
  );

// Klaim
const DetailClaimPage = () =>
  import(
    /* webpackChunkName: "Claim" */ "@/pages/new-claim/tracking-claim/index.vue"
  );
const NewClaimPage = () =>
  import(
    /* webpackChunkName: "Claim" */ "@/pages/new-claim/term-condition/index.vue"
  );
const NewFormClaimPage = () =>
  import(
    /* webpackChunkName: "Claim" */ "@/pages/new-claim/form-claim/index.vue"
  );
const NewSuccessClaimPage = () =>
  import(
    /* webpackChunkName: "Claim" */ "@/pages/new-claim/success-claim/index.vue"
  );

// Produk
const ProductPage = () =>
  import(
    /* webpackChunkName: "Product" */ "@/pages/new-product/Productpage.vue"
  );
const DetailProductPage = () =>
  import(
    /* webpackChunkName: "Product" */ "@/pages/new-product/product-details/ProductDetailPage.vue"
  );

// TNC
const TNCPage = () =>
  import(/* webpackChunkName: "Others" */ "@/pages/tnc/TermConditionPage.vue");

// Policy
const PolicyPage = () =>
  import(/* webpackChunkName: "Others" */ "@/pages/policy/PolicyPage.vue");

// SK
const SKPage = () =>
  import(/* webpackChunkName: "Others" */ "@/pages/sk/SKPage.vue");

// FAQ
const FAQPage = () =>
  import(/* webpackChunkName: "FAQNew" */ "@/pages/new-faq/FAQPage.vue");
const detailFAQPage = () =>
  import(
    /* webpackChunkName: "DetailFAQ" */ "@/pages/new-faq/detail/detailFAQPage.vue"
  );

// Karantina
const KarantinaPage = () =>
  import(
    /* webpackChunkName: "Karantina" */ "@/pages/new-quarantine/Karantina.vue"
  );

// LILO
const LILOPage = () =>
  import(/* webpackChunkName: "LILO" */ "@/pages/new-lilo/lilo.vue");
const LILOPageSuccess = () =>
  import(/* webpackChunkName: "LILO Success" */ "@/pages/new-lilo/success.vue");

// COD
const CODPage = () =>
  import(/* webpackChunkName: "COD" */ "@/pages/new-cod/cod.vue");

// this page gonna be use for Mobile App to have shortener link
const ShortenerLink = () =>
  import(
    /* webpackChunkName: "ShortenerLink" */ "@/pages/shortenerLink/shortenerLink.vue"
  );

// Register
const RegisterPage = () => import("@/pages/new-register/Register.vue");

// Event and Tips
const EventAndTips = () =>
  import(
    /* webpackChunkName: "EventAndTips" */ "@/pages/new-event-and-tips/EventAndTips.vue"
  );
const EventAndTipsDetail = () =>
  import(
    /* webpackChunkName: "EventAndTips"*/ "@/pages/new-event-and-tips/detail/Detail.vue"
  );

// Membership
const MembershipSK = () =>
  import(
    /* webpackChunkName: MembershipSK */ "@/pages/sk/membership/index.vue"
  );

// TNC Mobile Apps
const TermAndConditions = () =>
  import(
    /* webpackChunkName: TermAndConditionsPageMobileApp */ "@/pages/mobile-app/terms-and-conditions/TermsAndConditions.vue"
  );

const EmailVerification = () =>
  import(/* webpackChunkName: "EmailVerification" */ "@/pages/email/index.vue");

const RecipientForm = () =>
  import(
    /* webpackChunkName: "MobileAppRecipientForm" */ "@/pages/mobile-app/recipient-form/RecipientForm.vue"
  );

const OrderSuccess = () =>
  import(
    /* webpackChunkName: OrderSuccess*/ "@/pages/order/section/payment-success/payment-success.vue"
  );

// Malaysia Pages
// Landing Page MY
const landingPageMY = () =>
  import(
    /* webpackChunkName: LandingPageMy*/ "@/pages/landing-page-my/landing-page-my.vue"
  );

// Checkrates MY
const CheckRatesMy = () =>
  import (
    /* webpackChunkName: CheckRatesMy */ "@/pages/new-check-price/CheckPriceMy.vue"
  )

// Claim MY
const DetailClaimPageMY = () =>
  import(
    /* webpackChunkName: "ClaimMy" */ "@/pages/new-claim/tracking-claim-my/index.vue"
  );
const NewClaimPageMY = () =>
  import(
    /* webpackChunkName: "ClaimMy" */ "@/pages/new-claim/term-condition-my/index.vue"
  );
const NewFormClaimPageMY = () =>
  import(
    /* webpackChunkName: "ClaimMy" */ "@/pages/new-claim/form-claim-my/index.vue"
  );
const NewSuccessClaimPageMY = () =>
  import(
    /* webpackChunkName: "ClaimMy" */ "@/pages/new-claim/success-claim-my/index.vue"
  );
  
// Tracking MY
const TrackingMY = () =>
  import(
    /* webpackChunkName: "TrackingMy" */ "@/pages/new-tracking/TrackingMY.vue"
  );

// Product MY
const ProductPageMY = () =>
  import(
    /* webpackChunkName: "ProductMy" */ "@/pages/new-product/ProductpageMY.vue"
  );
const DetailProductPageMY = () =>
  import(
    /* webpackChunkName: "ProductMy" */ "@/pages/new-product/product-details-my/ProductDetailPageMY.vue"
  );

//Agen
const NewAgent = () =>
  import(
    /* webpackChunkName: "NewAgentRevamp" */ "@/pages/new-agent-revamp/index.vue"
  );
const NewSuccessRegisterAgentRevamp = () =>
  import(
    /* webpackChunkName: "AgentSuccessRegisterRevamp" */ "@/pages/new-agent-revamp/success/Success.vue"
  );

// Game
const GameIntro = () =>
  import(
    /* webpackChunkName: "GameIntro" */ "@/pages/game/introduction.vue"
  );
const GameSpin = () =>
  import(
    /* webpackChunkName: "GameIntro" */ "@/pages/game/spin/spin.vue"
  );
const GameWin = () =>
  import(
    /* webpackChunkName: "GameIntro" */ "@/pages/game/spin/win/win.vue"
  );

// Blog Malaysia
const BlogMalaysia = () =>
  import(
    /* webpackChunkName: "BlogMalaysia" */ "@/pages/new-event-and-tips/BlogMalaysia.vue"
  );
const BlogMalaysiaDetail = () =>
  import(
    /* webpackChunkName: "BlogMalaysia"*/ "@/pages/new-event-and-tips/detail/BlogMalaysiaDetail.vue"
  );

// Update Info
const UpdateInfoRecipient = () =>
  import(
    /* webpackChunkName: "UpdateInfo" */ "@/pages/update-info/recipient/recipient.vue"
  );
const UpdateInfoRecipientSuccess = () =>
  import(
    /* webpackChunkName: "UpdateInfo" */ "@/pages/update-info/success/success-recipient.vue"
  );
const UpdateInfoRecipientUpdated = () =>
  import(
    /* webpackChunkName: "UpdateInfo" */ "@/pages/update-info/updated/updated-recipient.vue"
  );
const UpdateInfoRecipientExpired = () =>
  import(
    /* webpackChunkName: "UpdateInfo" */ "@/pages/update-info/expired/expired.vue"
  );

// Agent Location International
const AgentLocationInt = () =>
  import(
    /* webpackChunkName: "AgentLocationInt" */ "@/pages/agent-location-international/index.vue"
  );

// Aggregator Leaderboard
const AggregatorLeaderboard = () =>
  import(
    /* webpackChunkName: "AggregatorLeaderboard" */ "@/pages/aggregator/Aggregator.vue"
  );

// Dangerous Goods
const DangerousGoods = () =>
  import(
    /* webpackChunkName: "DangerousGoods" */ "@/pages/dangerous-goods/index.vue"
  );

// Webinar
const Webinar = () =>
  import(
    /* webpackChunkName: "Webinar" */ "@/pages/webinar/index.vue"
  );
const WebinarSuccess = () =>
  import(
    /* webpackChunkName: "WebinarSuccess" */ "@/pages/webinar/success/success.vue"
  );

// Tracking Agent
const TrackAgent = () =>
  import(
    /* webpackChunkName: "TrackAgent" */ "@/pages/track-agent/index.vue"
  );

// revamp order
// Single Order
const SingleOrderPage = () =>
  import(/* webpackChunkName: "SingleOrder" */ "@/pages/shipment/single-order/single-order.vue");

// Bulk Order
const BulkOrderPage = () =>
  import(/* webpackChunkName: "BulkOrder" */ "@/pages/shipment/bulk-order/bulk-order.vue");

const PaymentSuccessPage = () =>
  import(/* webpackChunkName: "SingleOrderSuccess" */ "@/pages/shipment/section/payment/payment-success/payment-success.vue");

const PaymentMethodPage = () =>
  import(/* webpackChunkName: "ShipmentPaymentMethod" */ "@/pages/shipment/section/payment/payment-method/payment-method-page.vue");

const PaymentDetailPage = () =>
  import(/* webpackChunkName: "ShipmentPaymentDetail" */ "@/pages/shipment/section/payment/payment-detail-page/payment-detail-page.vue");

const GenerateBarcode = () => 
  import (/* webpackChunkName: GenerateBarcode*/ '@/pages/shipment/section/payment/payment-success/barcode.vue');
// Liolio
const LiolioLearnFromExperts = () =>
  import("@/pages/liolio/learn-from-experts/index.vue");

Vue.use(VueRouter);

const routes = [
  // homepage 
  {
    path: "",
    name: "Home",
    component: NewLayout,
    children: [
      { path: "", component: Home },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  //webinar page
  {
    path: "/parcelpreneur/20mei",
    name: "Webinar",
    component: NewLayout,
    children: [
      { path: "/parcelpreneur/20mei", component: Webinar },
      { path: "/parcelpreneur/24mei", component: Webinar },
      {
        path: "/parcelpreneur/success",
        component: WebinarSuccess,
        name: "Pendaftaran webinar berhasil",
        props: true,
      },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  //dangerous goods page
  {
    path: "/dangerous-goods",
    name: "Dangerous Goods",
    component: NewLayout,
    children: [
      { path: "/dangerous-goods", component: DangerousGoods },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // aggregator page
  {
    path: "/leaderboard/lincah",
    name: "Aggregator",
    component: NewLayout,
    children: [
      { path: "/leaderboard/lincah", component: AggregatorLeaderboard },
      { path: "/leaderboard/everpro", component: AggregatorLeaderboard },
      { path: "/leaderboard/mengantar", component: AggregatorLeaderboard },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // update info recipient page
  {
    path: "/update-info",
    name: "Update Info",
    component: GeneralLayout,
    children: [
      { path: "/update-info", component: UpdateInfoRecipient },
      { path: "/update-info/success", component: UpdateInfoRecipientSuccess },
      { path: "/update-info/updated", component: UpdateInfoRecipientUpdated },
      { path: "/update-info/expired", component: UpdateInfoRecipientExpired },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // game page
  {
    path: "/ceocard",
    name: "Spin Introduction",
    component: GameLayout,
    children: [
      { path: "/ceocard", component: GameIntro },
      { path: "/ceocard/spin", component: GameSpin },
      { path: "/ceocard/spin/win", component: GameWin },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Malaysia
  {
    path: "/my",
    component: MalaysiaLayout,
    children: [
      {
        path: "",
        component: landingPageMY,
        name: "Landing Page Malaysia",
        meta: {
          auth: false,
          type: "",
          lang: "en",
        },
      },
      {
        path: "shipment",
        component: {
          render: (c) => c("router-view"),
        },
        children: [
          { path: "/my/shipment", component: ProductPageMY },
          {
            path: "/my/shipment/:product_name",
            component: DetailProductPageMY,
            props: true,
            name: "Shipment Detail",
          },
        ],
        name: "Shipment",
        meta: {
          auth: false,
          type: "",
          lang: "en",
        },
      },
      {
        path: 'rates',
        component: CheckRatesMy,
        name: "CheckRatesMy", 
        meta: {
          auth: false,
          type: "",
          lang: "en"
        }
      },
      {
        path: "/my/track/stt",
        component: TrackingMY,
        name: "Tracking Shipment Malaysia",
        props: true,
        meta: {
          auth: false,
          type: "",
          lang: "en"
        },
      },
      {
        path: "claim",
        component: () =>
          import(/* webpackChunkName: "Claim" */ "@/pages/new-claim"),
        children: [
          { path: "/my/claim", component: NewClaimPageMY, props: true },
          {
            path: "/my/claim/form",
            component: NewFormClaimPageMY,
            name: "Submit new claims",
            props: true,
          },
          {
            path: "/my/claim/success",
            component: NewSuccessClaimPageMY,
            name: "Successfully submit a new claim",
            props: true,
          },
          {
            path: "/my/claim/track",
            component: DetailClaimPageMY,
            name: "Claim Tracking",
            props: true,
          },
        ],
        name: "Claim",
        meta: {
          auth: false,
          type: "",
          lang: "en"
        },
      },
      {
        path: "blog",
        component: () =>
          import(
            /* webpackChunkName: "BlogMalaysia" */ "@/pages/new-event-and-tips"
          ),
        children: [
          { path: "/my/blog", component: BlogMalaysia },
          {
            path: "/my/blog/:blog_slug",
            name: ":blog_slug",
            component: BlogMalaysiaDetail,
            props: true,
          },
        ],
        name: "Blog",
        meta: {
          auth: false,
          type: "",
        },
      },
    ],
  },
  //new agent page
  {
    path: "/agen",
    name: "Daftar Agen",
    component: NewLayout,
    children: [
      { path: "/agen", component: NewAgent },
      { path: "/agen/registration/submit", component: NewAgent },
      {
        path: "/agen/registration-success/result/",
        component: NewSuccessRegisterAgentRevamp,
        name: "Pendaftaran berhasil",
        props: true,
      },
      { path: "/agen/track/phonenumber", component: TrackAgent },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // FAQ
  {
    path: "/faq",
    component: GeneralLayout,
    children: [
      { path: "/faq", component: FAQPage },
      {
        path: "/faq/:category",
        beforeEnter: (r, _, next) => {
          if (r.params.category === "apps") {
            next({ path: "/faq/apps/pick-up", query: { page: 1 } });
          } else {
            next({
              path: "/faq/bantuan/jenis-pengiriman-&-layanan",
              query: { page: 1 },
            });
          }
        },
      },
      {
        path: "/faq/:category/:topic",
        component: detailFAQPage,
        props: true,
        name: ":topic",
      },
    ],
    name: "FAQ",
    meta: {
      auth: false,
      type: "",
    },
  },
  // Lokasi Agen
  {
    path: "/lokasi-agen",
    name: "Lokasi Agen",
    component: GeneralLayout,
    children: [
      { path: "/lokasi-agen", component: AgentLocation },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Lokasi Agent Internasional
  {
    path: "/lokasi-agen/pengiriman-internasional",
    name: "Lokasi Agen",
    component: GeneralLayout,
    children: [
      { path: "/lokasi-agen/pengiriman-internasional", component: AgentLocationInt },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Korporasi
  {
    path: "/korporasi",
    name: "Korporasi",
    component: GeneralLayout,
    children: [
      { path: "/korporasi", component: Corporation },
      { path: "form", component: CorporationForm, name: "Formulir Bisnis" },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Karir
  {
    path: "/career",
    name: "Karir",
    component: GeneralLayout,
    children: [
      { path: "/career", component: NewCareerPage, props: true },
      { path: "/career/jobs", component: NewCareerListPage, props: true },
      {
        path: "/career/detail/:career_id/:position",
        component: NewDetailCareerPage,
        props: true,
        name: ":position",
      },
      {
        path: "/career/form/:career_id",
        component: NewCareerForm,
        props: true,
        name: "Form Lowongan Karir",
      },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Tentang Kami
  {
    path: "/about",
    name: "Tentang Kami",
    component: GeneralLayout,
    children: [
      { path: "/about", component: AboutPage },
      {
        path: "/about/board/:id",
        component: BoardPage,
        props: true,
        name: "Pimpinan Kami",
      },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Produk
  {
    path: "/product",
    name: "Pengiriman",
    component: GeneralLayout,
    children: [
      { path: "/product", component: ProductPage },
      {
        path: "/product/:product_name",
        component: DetailProductPage,
        props: true,
        name: "Detail",
      },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Promo
  {
    path: "promo",
    name: "Promo List",
    component: GeneralLayout,
    children: [
      { path: "/promo", component: NewProgramPage },
      {
        path: "/promo/detail/:program_slug",
        component: NewDetailPromoPage,
        props: true,
        name: ":program_slug",
      },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Tarif
  {
    path: "ongkir",
    name: "Cek Ongkir",
    component: GeneralLayout,
    children: [
      { path: "/ongkir", component: CheckRates },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Tracking STT
  {
    path: "/track/stt",
    name: "Lacak Pengiriman",
    component: GeneralLayout,
    children: [
      { path: "/track/stt", component: Tracking },
    ],
    props: true,
    meta: {
      auth: false,
      type: "",
    },
  },
  // Klaim
  {
    path: "/klaim",
    name: "Klaim",
    component: GeneralLayout,
    children: [
      { path: "/klaim", component: NewClaimPage, props: true },
      {
        path: "/klaim/form",
        component: NewFormClaimPage,
        name: "Ajukan Klaim Baru",
        props: true,
      },
      {
        path: "/klaim/success",
        component: NewSuccessClaimPage,
        name: "Sukses Ajukan Klaim Baru",
        props: true,
      },
      {
        path: "/klaim/track",
        component: DetailClaimPage,
        name: "Lacak Klaim",
        props: true,
      },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Register
  {
    path: "/register",
    name: "Daftar Akun",
    component: GeneralLayout,
    children: [
      { path: "/register", component: RegisterPage },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Karantina
  {
    path: "/karantina",
    name: "Karantina",
    component: GeneralLayout,
    children: [
      { path: "/karantina", component: KarantinaPage },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // LILO
  {
    path: "/lilo",
    name: "Fulfillment",
    component: GeneralLayout,
    children: [
      { path: "/lilo", component: LILOPage, props: true },
      {
        path: "/lilo/success",
        component: LILOPageSuccess,
        props: true,
        name: "liloSuccess",
      },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // COD
  {
    path: "/cod",
    name: "COD",
    component: GeneralLayout,
    children: [
      { path: "/cod", component: CODPage },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Info Mitra
  {
    path: "/info-mitra",
    name: "Info Mitra",
    component: GeneralLayout,
    children: [
      { path: "/info-mitra", component: EventAndTips },
      {
        path: "/info-mitra/:corporate_slug",
        name: ":corporate_slug_mitra",
        component: EventAndTipsDetail,
        props: true,
      },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Info Seller
  {
    path: "/info-seller",
    component: GeneralLayout,
    children: [
      { path: "/info-seller", component: EventAndTips },
      {
        path: "/info-seller/:corporate_slug",
        name: ":corporate_slug_seller",
        component: EventAndTipsDetail,
        props: true,
      },
    ],
    name: "Info Seller",
    meta: {
      auth: false,
      type: "",
    },
  },
  // revamp order
  // Single Order
  {
    path: "/shipment",
    name: "Kirim paket",
    component: NewLayout,
    redirect: "/shipment/pickup-order",
    children: [
      {
        path: "/shipment/dropoff-order",
        component: SingleOrderPage,
        name: "isi detail pengiriman",
        meta: {
          auth: false,
          type: "",
          typeOrder: "dropoff",
        },
      },
      {
        path: "/shipment/pickup-order",
        component: SingleOrderPage,
        name: "isi detail pengiriman",
        meta: {
          auth: false,
          type: "",
          typeOrder: "pickup",
        },
      },
      {
        path: "/shipment/dropoff-order/bulk",
        component: BulkOrderPage,
        name: "isi detail pengiriman",
        meta: {
          auth: false,
          type: "",
          typeOrder: "dropoff",
          bulk: true,
        },
      },
      {
        path: "/shipment/pickup-order/bulk",
        component: BulkOrderPage,
        name: "isi detail pengiriman",
        meta: {
          auth: false,
          type: "",
          typeOrder: "pickup",
          bulk: true,
        },
      },
      {
        path: "/shipment/payment-success/:invoice_id",
        component: PaymentSuccessPage,
        name: "pembayaran sukses",
        meta: {
          auth: false,
          type: "",
        },
      },
      {
        path: "/shipment/payment-method/:invoice_id?",
        component: PaymentMethodPage,
        name: "metode pembayaran",
        meta: {
          auth: false,
          type: "",
        },
      },
      {
        path: "/shipment/payment-detail/:invoice_id",
        component: PaymentDetailPage,
        name: "detail pembayaran",
        meta: {
          auth: false,
          type: "",
        },
      },
    ],
  },
  // barcode
  {
    path: "/shipment/barcode/:invoice_id",
    component: BlankLayout,
    children: [
      {
        path: "/shipment/barcode/:invoice_id",
        component: GenerateBarcode
      },
    ],
    name: "Generate Barcode",
    meta: {
      auth: false,
      type: "",
    },
  },
  // Legacy order redirects
  { path: "/pickup-order", redirect: "/shipment/pickup-order" },
  { path: "/pickup-order/*", redirect: "/shipment/pickup-order" },
  { path: "/dropoff-order", redirect: "/shipment/dropoff-order" },
  { path: "/dropoff-order/*", redirect: "/shipment/dropoff-order" },
  {
    path: "/payment-success/:invoice_id",
    name: "Kirim Paket",
    component: GeneralLayout,
    children: [
      { path: "/payment-success/:invoice_id", component: OrderSuccess },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // SK
  {
    path: "/sk",
    component: GeneralLayout,
    children: [
      { path: "/sk", component: SKPage },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Email Verification
  {
    path: "/email/verification/:token",
    component: GeneralLayout,
    children: [
      { path: "/email/verification/:token", component: EmailVerification },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // TNC
  {
    path: "/app/tnc",
    component: GeneralLayout,
    children: [
      { path: "/app/tnc", component: TNCPage },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // Policy
  {
    path: "/app/policy",
    component: GeneralLayout,
    children: [
      { path: "/app/policy", component: PolicyPage },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  {
    // this page gonna be use for Mobile App to have shortener link
    path: "/link/:code",
    name: "Shortener Link",
    component: GeneralLayout,
    children: [
      { path: "/link/:code", component: ShortenerLink },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // App Membership
  {
    // this page gonna be use for Mobile App to have shortener link
    path: "/app/t&c",
    name: "Membership SK",
    component: GeneralLayout,
    children: [
      { path: "/app/t&c", component: MembershipSK },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // App Recipient Form
  {
    path: "/app/recipient-form/:id",
    name: "Recipient Form",
    component: GeneralLayout,
    children: [
      { path: "/app/recipient-form/:id", component: RecipientForm },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // App TNC
  {
    path: "/app/terms-and-conditions/:term_and_cond_id",
    name: "Term and Conditions",
    component: GeneralLayout,
    children: [
      { path: "/app/terms-and-conditions/:term_and_cond_id", component: TermAndConditions },
    ],
    meta: {
      auth: false,
      type: "",
    },
  },
  // liolio
  {
    path: "/liolio",
    name: "Liolio - Learn from Experts",
    component: GeneralLayout,
    redirect: "/",
    children: [
      {
        path: "/liolio/:name",
        component: LiolioLearnFromExperts
      }
    ],
    meta: {
      auth: false,
      type: ""
    }
  },
  // not registered page
  {
    path: "/*",
    redirect: "/",
  },
];
const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
